import React from "react";
import PropTypes from "prop-types";
import PremierDeliveryLoading from "../../components/PremierDeliveryLoading/index.jsx";
import TermsAndConditionsModal from "../../containers/TermsAndConditionsModalContainer";
import { Portal } from "../../helpers";
import style from "./styles";

const hasError = (apiError, errorMessage, error, payload) =>
  apiError || errorMessage || error || payload;

const hasData = (countriesData, countryData, content) =>
  content && countriesData && countryData;

const freeTrialContentReady = (offeredFreeTrial, firstName) =>
  offeredFreeTrial ? firstName : true;

const PremierPageFrame = ({
  countriesData,
  countryData,
  content,
  apiError,
  errorMessage,
  error,
  payload,
  children,
  modalVisible,
  offeredFreeTrial,
  firstName,
}) => {
  if (
    hasData(countriesData, countryData, content) &&
    freeTrialContentReady(offeredFreeTrial, firstName)
  ) {
    return (
      <React.Fragment>
        <div className={style.PremierPageFrame}>{children}</div>
        {modalVisible && (
          <Portal>
            <TermsAndConditionsModal content={content} />
          </Portal>
        )}
      </React.Fragment>
    );
  } else if (!hasError(apiError, errorMessage, error, payload)) {
    return <PremierDeliveryLoading />;
  }
  return null;
};

PremierPageFrame.propTypes = {
  countriesData: PropTypes.array,
  content: PropTypes.object,
  children: PropTypes.any,
  countryData: PropTypes.object,
  apiError: PropTypes.any,
  errorMessage: PropTypes.any,
  error: PropTypes.any,
  payload: PropTypes.any,
  modalVisible: PropTypes.bool,
  offeredFreeTrial: PropTypes.bool,
  firstName: PropTypes.string,
};

export default PremierPageFrame;
